import React from "react";
import { Box, Typography } from "@mui/material";
import color from "../../../Constants/colors";

interface Props {
  label: string;
  hint?: string;
  children: React.ReactNode;
}

const VoicesField: React.FC<Props> = ({ label, hint, children }) => {
  return (
    <Box>
      <Typography
        variant="body2"
        sx={{
          mb: hint ? 0.25 : 0.75,
          fontWeight: 600,
          fontSize: "0.85rem",
          color: color.gray900,
        }}
      >
        {label}
      </Typography>
      {hint && (
        <Typography
          variant="caption"
          sx={{ mb: 1, display: "block", color: color.gray600 }}
        >
          {hint}
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default VoicesField;
